// src/hooks/useAppName.ts
import { useEffect, useState } from "react";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

// Optionnel: fallback web via variable d'env ou title
const FALLBACK_WEB_NAME =
  import.meta.env.VITE_APP_NAME || "StriFit";

export function useAppName() {
  const [name, setName] = useState<string>(FALLBACK_WEB_NAME);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        if (Capacitor.isNativePlatform()) {
          const info = await App.getInfo(); // { name, id, version, build }
          if (mounted && info?.name) setName(info.name);
        }
      } catch {
        /* ignore: on garde le fallback web */
      }
    })();
    return () => { mounted = false; };
  }, []);

  return name;
}
